import { fetchGraphQLRaw } from 'api/graphql/raw'
import { Variables, RequestParameters } from 'relay-runtime'
import { trackError } from 'services/analytics'
import { buildGraphQLResponseWithErrorMessage } from 'services/error'
import { withHydrateDatetime } from 'relay-nextjs/date'

export function createCookieAwareRequestHandler(cookie?: string) {
  return async (params: RequestParameters, variables: Variables) => {
    let response: Response | null = null

    if (!params.text) {
      throw new Error('No operation to execute')
    }

    try {
      response = await fetchGraphQLRaw(params.text, variables, cookie)
    } catch (error) {
      // This only happens when a network error happens
      // Note that this error can be the dreaded 'TypeError: Failed to fetch'
      // which is not always an actual error, but a sign that the request was aborted
      // because for example the user navigated away from the page.
      // We capture it anyway so we can choose in Sentry whether to treat it as an error or not.

      trackError(error as Error, 'high', {
        params,
        variables,
        cookie,
        function: 'fetchGraphQLRaw',
        caller: 'createCookieAwareRequestHandler',
      })

      return buildGraphQLResponseWithErrorMessage('Network Error. Please try again soon')
    }

    if ([502, 503, 504, 408].includes(response?.status)) {
      return buildGraphQLResponseWithErrorMessage('Service unavailable. Please try again soon')
    }

    if (response?.status >= 500) {
      return buildGraphQLResponseWithErrorMessage('Internal Error. Our team has been notified')
    }

    if (response?.headers?.get('content-type')?.match(/^application\/json/g)) {
      const text = await response.text()
      return JSON.parse(text, withHydrateDatetime)
    }

    return buildGraphQLResponseWithErrorMessage('Invalid response format received')
  }
}
